"use client";

import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Loader2, Trash2 } from "lucide-react";
import { useToast } from "../hooks/use-toast";

const CreateSubAccount = ({
  open,
  setOpen,
  onCreate,
  onFunds,
  setSubAccountName,
  subAccountName,
  loading,
  accounts,
}) => {
  const handleCreate = () => {
    onCreate?.();
  };
  const { toast } = useToast();
  const handleFunds = () => {
    onFunds?.();
  };
  const handleLimit = () => {
    toast({
      description: "User cannot have more 5 accounts at a time.",
      variant: "eighty",
    });
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <button
        onClick={handleFunds}
        className="py-2 px-20 text-sm font-bold text-black border mr-5 border-gray-300 rounded-full bg-white hover:opacity-90"
      >
        Transfer funds
      </button>

      <DialogTrigger asChild>
        <Button className="bg-gradient-to-r from-pink-500 to-purple-500 text-white px-16 py-2 rounded-full">
          Create new sub account
        </Button>
      </DialogTrigger>

      <DialogContent className="max-w-md p-6 rounded-lg shadow-lg">
        <DialogHeader>
          <DialogTitle className="text-[24px] text-brand-primary font-semibold mt-5 mb-3">
            Create new sub account
          </DialogTitle>
        </DialogHeader>
        <div className="mb-5">
          <div className="relative w-full">
            <p className="text-[14px] text-text-secondary font-normal mb-2">
              Sub account name
            </p>
            <input
              type="text"
              placeholder="Sub account name"
              value={subAccountName}
              onChange={(e) => setSubAccountName(e.target.value)}
              className="border-[1px] rounded-[10px] border-bg-border text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-white text-[14px] font-normal px-5 py-4"
            />
          </div>
        </div>
        <div className="grid grid-cols-2">
          <div className="pr-2">
            <DialogClose className="w-full">
              <Button className="text-text-secondary font-semibold text-[14px] rounded-full bg-transparent border-[1px] hover:opacity-90 w-full py-5">
                Cancel
              </Button>
            </DialogClose>
          </div>
          <div className="pl-2">
            <Button
              className="text-sm font-semibold text-white rounded-full bg-gradient-to-r from-purple-500 to-rose-600 hover:opacity-90 w-full py-5"
              onClick={handleCreate}
            >
              {loading && <Loader2 className="animate-spin w-4 h-4" />}
              Create sub account
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CreateSubAccount;
